

























































































































































































































import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import BuildEntityListComponent from '@/Shared/CommonEntityMixins/EntityListComponentMixin';
import { ActionMethod } from '@/Shared/CommonEntityMixins/Enums';
import { ViolationCode } from './ViolationCode';
import { UrlOptions } from '@/Shared/CommonEntityMixins/UrlConfig';
import { LocationLookupType } from '@/Stores/LookupStore';

const baseListComponent = BuildEntityListComponent<ViolationCode>();
const violationCodes = mixins(LocationBasedMixin, baseListComponent).extend({
    data() {
        return {
            i18nPrefix: 'admin.lotMaintenance.violationCodes',
            LocationLookupType,
        };
    },
    components: {
        RadioToggle: () => import('@/Shared/RadioToggle.vue'),
    },
    computed: {
        entityUrls(): UrlOptions {
            const urls: UrlOptions = {
                get: {
                    url: `/${this.location}/lotmaintenance/getviolationcodes`,
                    urlAction: ActionMethod.GET
                },
                update: {
                    url: `/${this.location}/lotmaintenance/upsertviolationcodelkup`,
                    urlAction: ActionMethod.POST
                },
                delete: {
                    url: `/${this.location}/lotmaintenance/deleteviolationcodelkup`,
                    urlAction: ActionMethod.PUT
                }
            };

            return urls;
        }
    }
});

export default violationCodes;
